export default {
  blog() {
    return {
      path: '/blog.json',
      resolve: (response, mappers) => {
        let blog = response.results[0];

        let socials = response.socials;

        return mappers.merge({
          title: blog.title,
          labels: {
            post: blog.post_label,
            author: blog.author_label
          },
          socialMedias: socials
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/resources/Blog.js